import Vuex from 'vuex'

import search from '../routes/SRP/store'
import { store as opportunity } from '~/opportunity'
import { instance } from '~/store'

export const store = new Vuex.Store({
  modules: {
    instance,
    opportunity,
    search
  }
})

export default Vuex
